import React, { memo, useCallback, useEffect } from 'react';

import { Form, Formik } from 'formik';
import type { FormikProps } from 'formik';
import { initialFilterValues } from 'v2/interfaces/rating';
import type { IFilter } from 'v2/interfaces/rating';
import productRatingService from 'v2/services/rating/product';

import Fields from './Fields';

const Filters = memo(() => {
  useEffect(() => {
    productRatingService.setFilter(initialFilterValues);
  }, []);

  const onSubmit = useCallback((values: IFilter, { setSubmitting }: FormikProps<IFilter>) => {
    for (const v in values) {
      const key = v as keyof IFilter;

      if (!values[key] || values[key] === null || values[key] === '') {
        delete values[key];
      }
    }

    productRatingService.setFilter(values);
    setSubmitting(false);
  }, []);

  return (
    <div className='w-full rounded-sm bg-white p-5 shadow-sm [&_.--align-end]:flex [&_.--align-end]:items-end [&_.--align-end]:justify-end [&_.--align-end]:pl-3 [&_.--align-end_button:last-child]:ml-6 [&_.--align-end_button:last-child]:w-full [&_form]:w-full'>
      <Formik initialValues={initialFilterValues} onSubmit={onSubmit}>
        {() => (
          <Form>
            <Fields />
          </Form>
        )}
      </Formik>
    </div>
  );
});

export default Filters;
